export default __webpack_public_path__ + "static/shrub-1e0093887d0b977d0912eb4f2c38f3be.png";